import React from 'react'
import { ApexCharts, moment } from '../../../../Components'
import { LogAcessoGetAcessosPorHora } from '../../../../Service/ApiService'
import ChartCard from '../ChartCard'
import { CORES, eixoContagem, formatarNumero, useIndicador } from '../helpers'
import { Destaque } from '../styles'

const HORAS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, '0'))

// Distribuição por hora do último dia do período (hoje, nos filtros que terminam hoje)
export default function AcessosPorHora({ filters }) {
  const { status, data } = useIndicador(LogAcessoGetAcessosPorHora, filters, (d) => d.length === 0)
  const dia = moment(filters?.dtTermino)
  const ehHoje = dia.isSame(moment(), 'day')

  const porHora = HORAS.map((hora) => data?.find((item) => item.hora === hora)?.qtdeHora || 0)
  const pico = porHora.reduce((maior, qtde, i) => (qtde > porHora[maior] ? i : maior), 0)
  const horaAtual = porHora[moment().hour()]

  const options = {
    chart: { type: 'area' },
    colors: [CORES.laranja],
    stroke: { curve: 'smooth', width: 3 },
    fill: { type: 'gradient', gradient: { opacityFrom: 0.45, opacityTo: 0.05 } },
    xaxis: { categories: HORAS.map((h) => `${h}h`), tickAmount: 8, labels: { rotate: 0 }, tooltip: { enabled: false } },
    yaxis: eixoContagem(porHora),
    tooltip: { y: { formatter: formatarNumero } },
  }

  return (
    <ChartCard
      title="Acessos por hora"
      subtitle={`${ehHoje ? 'Hoje' : dia.format('DD/MM/YYYY')}${status === 'ok' ? ` · pico às ${HORAS[pico]}h` : ''}`}
      status={status}
      destaque={
        ehHoje && (
          <Destaque>
            <strong>{formatarNumero(horaAtual)}</strong>
            <span>na hora atual</span>
          </Destaque>
        )
      }
    >
      <ApexCharts options={options} series={[{ name: 'Acessos', data: porHora }]} type="area" height={280} />
    </ChartCard>
  )
}
